import classnames from '@helpers/misc/classnames'
import useIsDarkMode from '@hooks/useIsDarkMode'

export interface Props {
  children?: React.ReactNode
  className?: string
}
export function ReservationLabel(props: Props) {
  const isDarkMode = useIsDarkMode()

  return (
    <div
      className={classnames('text-sm', props.className, {
        'text-gray-500': !isDarkMode,
        'text-gray-300': isDarkMode
      })}>
      {props.children}
    </div>
  )
}
